import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

const PhoneBillCollapsibleSection = ({
  title,
  subtitle,
  count,
  defaultOpen = true,
  variant = 'default',
  children,
}) => {
  const [open, setOpen] = useState(defaultOpen);

  const headerClass = [
    'phone-bill-section-header',
    variant !== 'default' ? `phone-bill-section-header--${variant}` : '',
  ]
    .filter(Boolean)
    .join(' ');

  const sectionClass = [
    'phone-bill-section',
    open ? 'phone-bill-section--open' : 'phone-bill-section--collapsed',
  ].join(' ');

  return (
    <section className={sectionClass}>
      <button
        type="button"
        className={headerClass}
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
      >
        <div className="phone-bill-section-header-text">
          <span className="phone-bill-section-title">{title}</span>
          {count != null && count > 0 && (
            <span className="phone-bill-section-count">({count})</span>
          )}
          {subtitle && <span className="phone-bill-section-subtitle">{subtitle}</span>}
        </div>
        <FontAwesomeIcon icon={open ? faChevronUp : faChevronDown} className="phone-bill-section-chevron" />
      </button>
      {open && <div className="phone-bill-section-body">{children}</div>}
    </section>
  );
};

export default PhoneBillCollapsibleSection;
